import { ProductCategory } from './ProductCategory';
export class Service {
  constructor() {
    this.productCategory = [new ProductCategory()];
    (this.name = ''), (this.id = '');
    (this.code = ''), (this.amount = ''), (this.status = false);
    this.Image = '';
    this.remarks = '';
  }
}
